import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import _cloneDeep from 'lodash-es/cloneDeep';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseCacheService } from '@shared/core/services/base-cache.service';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor(private cacheService: BaseCacheService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // NOTE: uglyhack due to no `meta` field currently
    // https://github.com/angular/angular/issues/18155
    if (req.method !== 'GET' || !(req as any).meta || !(req as any).meta.cache) {
      return next.handle(req);
    }

    const cacheKey = this.getCacheKey(req);

    const cachedReponse = this.cacheService.get<HttpResponse<any>>(cacheKey);

    if (cachedReponse) {
      // NOTE: remove `cloneDeep` usage when there are no mutations on all cached requests data
      return of(cachedReponse.clone({ body: _cloneDeep(cachedReponse.body) }));
    }

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          // NOTE: remove `cloneDeep` usage when there are no mutations on all cached requests data
          this.cacheService.set(cacheKey, event.clone({ body: _cloneDeep(event.body) }));
        }
      }),
    );
  }

  private getCacheKey(req: HttpRequest<any>): string {
    const { urlWithParams } = req;

    return urlWithParams;
  }
}
